module.exports = __webpack_public_path__ + "static/media/置顶 (2).c5b85c25.svg";